// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .graph-selection {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  width: calc(100% - 10px);
}
:host .section-item {
  width: 100%;
}
:host .section-item-block mat-select, :host input, :host span {
  width: calc(100% - 15px);
}
:host .section-inline-number {
  display: inline-block;
  width: 60px;
}
:host .section-inline-number input {
  width: inherit;
  text-align: center;
}
:host .section-inline-number span {
  width: 65px;
  text-align: left;
}
:host .section-inline-toggle {
  display: inline-block;
  width: 50px;
  text-align: center;
}
:host .section-inline-toggle span {
  width: inherit;
}
:host .section-inline-toggle mat-slide-toggle {
  width: inherit;
  padding-left: 10px;
}
:host .section-inline-toggle-ext span {
  width: 85px;
}
:host .section-inline-toggle-ext mat-slide-toggle {
  padding-left: 20px;
}
:host .section-inline-color {
  display: inline-block;
  width: 60px;
}
:host .section-inline-color input {
  width: 60px !important;
  text-align: center;
}
:host .section-inline-color span {
  width: 65px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-graph/graph-property/graph-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-graph/graph-property/graph-property.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;ACAR;ADGI;EACI,WAAA;ACDR;ADII;EACI,wBAAA;ACFR;ADKI;EACI,qBAAA;EACA,WAAA;ACHR;ADMI;EACI,cAAA;EACA,kBAAA;ACJR;ADOI;EACI,WAAA;EACA,gBAAA;ACLR;ADQI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;ACNR;ADSI;EACI,cAAA;ACPR;ADUI;EACI,cAAA;EACA,kBAAA;ACRR;ADWI;EACI,WAAA;ACTR;ADYI;EACI,kBAAA;ACVR;ADaI;EACI,qBAAA;EACA,WAAA;ACXR;ADcI;EACI,sBAAA;EACA,kBAAA;ACZR;ADeI;EACI,WAAA;ACbR","sourcesContent":[":host {\n    .graph-selection {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        width:calc(100% - 10px);\n    }\n\n    .section-item {\n        width: 100%;\n    }\n\n    .section-item-block mat-select, input, span {\n        width:calc(100% - 15px);\n    }\n\n    .section-inline-number {\n        display: inline-block;\n        width: 60px;\n    }\n\n    .section-inline-number input {\n        width: inherit;\n        text-align: center;\n    }\n\n    .section-inline-number span {\n        width: 65px;\n        text-align: left;\n    }\n\n    .section-inline-toggle {\n        display: inline-block;\n        width: 50px;\n        text-align: center;\n    }\n\n    .section-inline-toggle span {\n        width: inherit;\n    }\n\n    .section-inline-toggle mat-slide-toggle {\n        width: inherit;\n        padding-left: 10px;\n    }\n\n    .section-inline-toggle-ext span {\n        width: 85px;\n    }\n\n    .section-inline-toggle-ext mat-slide-toggle {\n        padding-left: 20px;\n    }\n\n    .section-inline-color {\n        display: inline-block;\n        width: 60px;\n    }\n\n    .section-inline-color input {\n        width: 60px !important;\n        text-align: center;\n    }\n\n    .section-inline-color span {\n        width: 65px;\n    }\n}",":host .graph-selection {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  width: calc(100% - 10px);\n}\n:host .section-item {\n  width: 100%;\n}\n:host .section-item-block mat-select, :host input, :host span {\n  width: calc(100% - 15px);\n}\n:host .section-inline-number {\n  display: inline-block;\n  width: 60px;\n}\n:host .section-inline-number input {\n  width: inherit;\n  text-align: center;\n}\n:host .section-inline-number span {\n  width: 65px;\n  text-align: left;\n}\n:host .section-inline-toggle {\n  display: inline-block;\n  width: 50px;\n  text-align: center;\n}\n:host .section-inline-toggle span {\n  width: inherit;\n}\n:host .section-inline-toggle mat-slide-toggle {\n  width: inherit;\n  padding-left: 10px;\n}\n:host .section-inline-toggle-ext span {\n  width: 85px;\n}\n:host .section-inline-toggle-ext mat-slide-toggle {\n  padding-left: 20px;\n}\n:host .section-inline-color {\n  display: inline-block;\n  width: 60px;\n}\n:host .section-inline-color input {\n  width: 60px !important;\n  text-align: center;\n}\n:host .section-inline-color span {\n  width: 65px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
